// src/components/common/ConfirmModal.jsx

import React from "react";
import { Dialog } from "@headlessui/react";

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
  return (
    <Dialog open={isOpen} onClose={onCancel} className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/40" />
      <Dialog.Panel className="relative z-50 bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg w-full max-w-sm">
        <Dialog.Title className="text-lg font-bold text-gray-800 dark:text-white">
          {title}
        </Dialog.Title>
        <Dialog.Description className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          {message}
        </Dialog.Description>
        <div className="mt-4 flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-shade4"
          >
            Confirm
          </button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
}
